import { useEffect, useState } from "react";
import { faBars, faCaretDown, faClose, faSignOut } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import classNames from "classnames";

import { routeList } from "./route-list";
import { useAuthentication } from "../../services/authentication/authentication.context";



export const Header = ({ pageTitle }) => {

    const navigateTo = useNavigate();

    const [openServices, setOpenServices] = useState(false);
    const [showNav, setShowNav] = useState(false);

    const { account, isAuthenticated, signoutUser, token } = useAuthentication();

    useEffect(() => {
        document.title = pageTitle;
        window.scrollTo(0, 0)
    }, [pageTitle]); // The effect runs whenever pageTitle changes

    return (
        <header>
            <div className="header-container gl">
                <div className="app-logo">
                    <img src="/logos/rwt.png" alt="" className="logo-img" />
                </div>
                <div className="app-names">
                    <div className="app-f-name">Random</div>
                    <div className="app-s-name">Walk</div>
                    <div className="app-th-name">Tech</div>
                </div>

            </div>
            <div className="mobi-toggle-nav">
                <button className="tr-btn nav-t-btn" onClick={() => setShowNav(s => !s)}>
                    <FontAwesomeIcon icon={showNav ? faClose : faBars} />
                </button>
            </div>
            <div className={classNames("rnd-nav", { "sh-nav": showNav })}>
                {routeList.map((item, k) => {
                    return (
                        <div>
                            <button
                                className="rnd-nav-button"
                                key={k}
                                onClick={() => {
                                    item.ismenu ? setOpenServices(o => !o)
                                        : navigateTo(item.uri);
                                }}
                            >
                                <FontAwesomeIcon icon={item.icon} />
                                <span className="rnd-btn-caption">{item.pathName}</span>
                                {item.ismenu && (
                                    <FontAwesomeIcon
                                        icon={faCaretDown}
                                        className={classNames('caret', { 'open-caret': openServices })}
                                    />
                                )}
                            </button>
                            {item.ismenu && (
                                <div className={classNames("sub-nav", { "open": openServices })}>
                                    {item.submenu?.map((subItem, indx) => {
                                        return (
                                            <button
                                                className="rnd-nav-button sub-btn"
                                                key={indx}
                                                onClick={() => {
                                                    navigateTo(`/services${subItem.pathName}`);
                                                }}
                                            >
                                                <FontAwesomeIcon icon={subItem.icon} />
                                                <span className="rnd-btn-caption sub-btn-cap">{subItem.name}</span>
                                            </button>
                                        )
                                    })}
                                </div>
                            )}
                        </div>
                    )
                })}

                {isAuthenticated &&
                    <div className="auth-buttons">
                        <button className="auth-button">
                            {account?.user?.names[0]}
                        </button>
                        <button 
                            className="auth-button logout"
                            onClick={async() => {
                                await signoutUser(token);
                                window.location.reload();
                            }}
                        >
                            <FontAwesomeIcon icon={faSignOut} className="auth-icon" />
                        </button>
                    </div>
                }
            </div>
        </header>
    )
}